export const STANDARD_DATE_FORMAT = 'dd.MM.yyyy';
export const FOREIGN_DATE_FORMAT = 'yyyy-MM-dd';
export const OWN_CONTRIBUTION_FALLBACK_FMS_KEY =
  'detailed.secondary.ownContribution.fallback';
export const FIRST_RISK_SUM_FALLBACK_FMS_KEY =
  'detailed.secondary.firstRiskSum.fallback';
export const DETAILED_SECONDARY_TRUE_FMS_KEY = 'detailed.secondary.true';
export const DETAILED_SECONDARY_FALSE_FMS_KEY = 'detailed.secondary.false';
export const MEDICAL_DISABILITY_COVERAGE = 'Medisinsk invaliditet';
export const DEATH_COVERAGE = 'Død';
export const MEDICAL_DISABILITY_COVERAGE_FULL_TIME =
  'Medisinsk invaliditet, heltid';
export const DEATH_COVERAGE_FULL_TIME = 'Død, heltid';
export const DETAILED_COVERAGE_SECTION_HOUSECONTENTS_SUPER =
  'detailed.coverageSection.houseContents.super';
export const DETAILED_PRIMARY_INSURANCE_VALIDITY_LABEL_FMS_KEY =
  'detailed.primary.insuranceValidity.label';
export const DETAILED_PRIMARY_DISCOUNT_LABEL_FMS_KEY =
  'detailed.primary.discount.label';
export const DETAILED_SECONDARY_COVERAGE_LABEL_FMS_KEY =
  'detailed.secondary.coverage.label';
export const DETAILED_SECONDARY_METER_SQUARED_LABEL_FMS_KEY =
  'detailed.secondary.meterSquared';
export const DETAILED_SECONDARY_COVERAGE_AMOUNT_LABEL_FMS_KEY =
  'detailed.secondary.coverageAmount.label';
export const DETAILED_SECONDARY_FALSE = 'detailed.secondary.false';
export const DETAILED_SECONDARY_TRUE = 'detailed.secondary.true';

export const policyNumberText = 'detailed.primary.policyNumber.label';
export const alisPolicyNumberText = 'detailed.primary.policyNumber.alis.label';

export enum OwnContributionValues {
  REDUCED_OWN_DAMAGE = '6 000 kr',
  DRIVER_AND_PASSENGER_ACCIDENT = '0 kr',
}
